import {putMethod} from '~/api'

async function put(request) {
    return await putMethod('/api/modifyStatus', request)
}

export {put}
